export default "__VITE_ASSET__B9hR_n9z__"